var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQrEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1992_12981)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3.5,
    width: 31,
    height: 25,
    rx: 1.5,
    fill: "white",
    stroke: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 5C1 4.17157 1.67157 3.5 2.5 3.5H30.5C31.3284 3.5 32 4.17157 32 5V9.5H1V5Z",
    fill: "#F2F2F2",
    stroke: "#595959"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.0556,
    y: 19.7778,
    width: 2.22222,
    height: 2.22222,
    transform: "rotate(-90 12.0556 19.7778)",
    fill: "white",
    stroke: "#595959",
    strokeWidth: 1.11111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.05556,
    y: 19.7778,
    width: 2.22222,
    height: 2.22222,
    transform: "rotate(-90 5.05556 19.7778)",
    fill: "white",
    stroke: "#595959",
    strokeWidth: 1.11111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.0556,
    y: 19.7778,
    width: 2.22222,
    height: 2.22222,
    transform: "rotate(-90 19.0556 19.7778)",
    fill: "white",
    stroke: "#595959",
    strokeWidth: 1.11111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.0556,
    y: 19.7778,
    width: 2.22222,
    height: 2.22222,
    transform: "rotate(-90 26.0556 19.7778)",
    fill: "white",
    stroke: "#595959",
    strokeWidth: 1.11111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.0556,
    y: 14.7778,
    width: 2.22222,
    height: 2.22222,
    transform: "rotate(-90 12.0556 14.7778)",
    fill: "white",
    stroke: "#595959",
    strokeWidth: 1.11111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.05556,
    y: 14.7778,
    width: 2.22222,
    height: 2.22222,
    transform: "rotate(-90 5.05556 14.7778)",
    fill: "white",
    stroke: "#595959",
    strokeWidth: 1.11111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.0556,
    y: 14.7778,
    width: 2.22222,
    height: 2.22222,
    transform: "rotate(-90 19.0556 14.7778)",
    fill: "white",
    stroke: "#595959",
    strokeWidth: 1.11111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.0556,
    y: 14.7778,
    width: 2.22222,
    height: 2.22222,
    transform: "rotate(-90 26.0556 14.7778)",
    fill: "white",
    stroke: "#595959",
    strokeWidth: 1.11111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.05556,
    y: 24.7778,
    width: 2.22222,
    height: 2.22222,
    transform: "rotate(-90 5.05556 24.7778)",
    fill: "white",
    stroke: "#595959",
    strokeWidth: 1.11111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.0556,
    y: 24.7778,
    width: 2.22222,
    height: 2.22222,
    transform: "rotate(-90 12.0556 24.7778)",
    fill: "white",
    stroke: "#595959",
    strokeWidth: 1.11111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.0556,
    y: 24.7778,
    width: 2.22222,
    height: 2.22222,
    transform: "rotate(-90 19.0556 24.7778)",
    fill: "white",
    stroke: "#595959",
    strokeWidth: 1.11111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 25.3334,
    width: 3.33333,
    height: 3.33333,
    transform: "rotate(-90 25.5 25.3334)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6.11111C8.5 5.49746 8.99746 5 9.61111 5C10.2248 5 10.7222 5.49746 10.7222 6.11111C10.7222 6.72476 10.2248 7.22222 9.61111 7.22222C8.99746 7.22222 8.5 6.72476 8.5 6.11111Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 6.11111C21.5 5.49746 21.9975 5 22.6111 5C23.2248 5 23.7222 5.49746 23.7222 6.11111C23.7222 6.72476 23.2248 7.22222 22.6111 7.22222C21.9975 7.22222 21.5 6.72476 21.5 6.11111Z",
    fill: "#595959"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1992_12981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQrEvent);
export default __webpack_public_path__ + "static/media/icon-qr-event.4b6fd569044fbd238d7fae81230ba7fa.svg";
export { ForwardRef as ReactComponent };